"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { usePyodideProgressSnackbar } from "#/features/codeRunner/hooks/usePyodideProgressSnackbar";
import { pythonRunner } from "#/features/codeRunner/lib/pythonRunner";
import { pyodideSlice } from "#/features/codeRunner/model/pyodideSlice";
import { useAppDispatch } from "#/store/hooks";

/** Delay after 100% so the progress bar animation completes before snackbar closes. */
const PROGRESS_COMPLETE_DELAY_MS = 400;

/**
 * Warm Pyodide once per playground segment visit.
 * Lives in playground layout so loading → page transitions do not restart init.
 */
export const usePlaygroundPyodideWarmup = () => {
  const $ = _c(3);
  const dispatch = useAppDispatch();
  usePyodideProgressSnackbar();
  let t0;
  let t1;
  if ($[0] !== dispatch) {
    t0 = () => {
      if (pythonRunner.isReady) {
        return;
      }
      let cancelled = false;
      dispatch(pyodideSlice.actions.setProgress({
        value: 0,
        stage: "Starting\u2026"
      }));
      let completeTimeoutId = null;
      pythonRunner.init({
        onProgress: (value, stage) => {
          if (!cancelled) {
            dispatch(pyodideSlice.actions.setProgress({
              value,
              stage
            }));
          }
        }
      }).catch(_temp).finally(() => {
        if (cancelled) {
          return;
        }
        completeTimeoutId = setTimeout(() => {
          completeTimeoutId = null;
          if (!cancelled) {
            dispatch(pyodideSlice.actions.clearProgress());
          }
        }, PROGRESS_COMPLETE_DELAY_MS);
      });
      return () => {
        cancelled = true;
        if (completeTimeoutId !== null) {
          clearTimeout(completeTimeoutId);
        }
        dispatch(pyodideSlice.actions.clearProgress());
      };
    };
    t1 = [dispatch];
    $[0] = dispatch;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
};
function _temp() {}